import React from 'react'

const ApplicationForm = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Application Form</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg " style={{textAlign:'justify',overflow:'hidden'}}>
      <p><strong>To</strong></p>

													<p>The State Public Information Officer/</p>

													<p>State Assistant Public Information Officer,</p>

													<p>(Name of the office with address)</p>

													<ol>
														<li>Full name of the applicant</li>
														<li>Address</li>
														<li>Particulars of information required:
															<ol style={{listStyleType:'lower-roman'}}>
																<li>Subject matter of information</li>
																<li>The period to which the information relates</li>
																<li>Description of the information required</li>
																<li>Whether information is required by post or in person
																	(the actual postal charges shall be included in
																	addition to the fees).</li>
																<li>In case by post (Ordinary, Registered or Speed)</li>
															</ol>
														</li>
													</ol>

													<hr />
													<div className="d-flex">
														<div className="">
															<p>Place:
																&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
															</p>

															<p>Date:
																&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
															</p>
														</div>

														<div className="ms-auto">
															<p >Signature of the Applicant</p>
														</div>
													</div>

													<h6>Acknowledgement</h6>

													<p>Received your application dated
														&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip; vide
														Diary No
														&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
														dated &hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
													</p>
													<hr />
													<div className='text-center'>
														<p>Name of the Department/Office/State Assistant Public Information Officer/State Public Information Officer/(Signature)</p>
														



													</div>
    </div>
    </div>
  )
}

export default ApplicationForm
